import { useState } from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import './Auth.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const submit = async event => {
    event.preventDefault();
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const response = await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Reset request failed.');
      setResult(data);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-root">
      <div className="auth-bg" />
      <div className="auth-card glass">
        <Link to="/login" className="auth-back">← Back to sign in</Link>
        <BrandLogo className="auth-logo" />
        <h1 className="auth-title">Reset your password</h1>
        <p className="auth-sub">Enter the email connected to your account.</p>

        {error && <div className="auth-error">{error}</div>}
        {result ? (
          <div className="auth-reset-result">
            <div className="auth-success">{result.message}</div>
            {result.resetUrl && (
              <a className="auth-dev-link" href={result.resetUrl}>
                Continue to password reset
                <small>Development link · expires in 30 minutes</small>
              </a>
            )}
          </div>
        ) : (
          <form className="auth-form" onSubmit={submit} noValidate>
            <div className="auth-field">
              <label htmlFor="reset-email">Email</label>
              <input id="reset-email" type="email" value={email} onChange={event => setEmail(event.target.value)} placeholder="you@example.com" autoComplete="email" required />
            </div>
            <button className="auth-btn" type="submit" disabled={loading}>
              {loading ? <span className="auth-spinner" /> : 'Create Reset Link'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}